
import { forwardRef, useEffect, useRef } from "react";
import { Dropdown, SplitButton } from "react-bootstrap";

type IndeterminateCheckboxProps = {
    indeterminate: any;
    children?: React.ReactNode;
    handleSelectedRows?: any;
    checked?: boolean;
    selectAllRows: boolean;
    onSelectAll: () => void;
    onDeselectAll: () => void;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const IndeterminateCheckbox = forwardRef<HTMLInputElement, IndeterminateCheckboxProps>(
    ({ indeterminate, onSelectAll, onDeselectAll, onChange, ...rest }, ref) => {
        const defaultRef = useRef();
        const resolvedRef: any = ref || defaultRef;

        useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);

        const handleSelectAll = () => {
            handleSelectAllFromPage();
            if (onSelectAll) onSelectAll();
        };

        const handleDeselectAll = () => {
            onChange({ target: { checked: false } } as React.ChangeEvent<HTMLInputElement>);
            if (onDeselectAll) onDeselectAll();
        };

        const handleSelectAllFromPage = () => {
            onChange({ target: { checked: true } } as React.ChangeEvent<HTMLInputElement>);
        };

        return (
            <>
                { onSelectAll !== undefined && onDeselectAll !== undefined ? <>
                    <SplitButton className="custom-split-button shadow-none" variant="link" title={<input type="checkbox" className="form-check-input shadow-none" ref={resolvedRef} {...rest} onChange={onChange} />}>
                        {/* <Dropdown.Item onClick={handleSelectAllFromPage}>Select on this page</Dropdown.Item> */}
                        <Dropdown.Item onClick={handleSelectAll} className="checkboxborder">Select all</Dropdown.Item>
                        <Dropdown.Item onClick={handleDeselectAll}>Deselect all</Dropdown.Item>
                    </SplitButton>
                </> : <>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" ref={resolvedRef} onChange={onChange} {...rest} />
                        <label htmlFor="form-check-input" className="form-check-label"></label>
                    </div>
                </>}
            </>
        );
    }
);